<template>
  <div>
    <el-scrollbar>
      <div class="formOuterBox">
        <div>
          <el-form :rules="rules">
            <el-col :span="12" style="margin-top:5px">
              <el-form-item label="假期名称" prop="vacationName" label-width="120px">
                <el-input v-model="vacationName" style="width: 150px"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <el-row :span="12">
            <el-form :rules="rules">
              <el-col>
                <el-form-item label="应用范围" prop="scope" label-width="120px">
                  <el-select v-model="scope" style="width: 150px">
                    <el-option v-for="item in scopeList" :key="item.value" :label="item.name" :value="item.value"/>
                    <!--                    <el-option label="全公司" value="fullCompany"></el-option>-->
                    <!--                    <el-option label="部门/人员" value="department"></el-option>-->
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form>
            <el-form-item v-if="scope === 'department'">
              <el-input v-model="selectedPerson" @click="departmentDialogVisible = true" placeholder="请选择"
                        style="width: 200px">
              </el-input>
            </el-form-item>
            <!--    弹窗界面    -->
            <div>
              <el-dialog title="选择部门与人员" v-model="departmentDialogVisible">
                <div class="box">
                  <div title="左">
                    <el-collapse accordion>
                      <el-collapse-item  title="鑫巨弘"  name="1" >
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                  <el-divider direction="vertical" style="height: 100%;"/>
                  <div title="右">
                <span class="global-buttons" style="position: absolute; bottom: 20px;">
                  <el-button @click="departmentDialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="departmentDialogVisible = false">确 定</el-button>
                </span>
                  </div>
                </div>
              </el-dialog>
            </div>
          </el-row>
          <el-col :span="16" style="margin-top:-5px">
            <el-form-item label="新员工请假" label-width="120px">
              <el-select v-model="employeeLeave" style="width: 300px">
                <el-option label="入职即可请假" value="entryLeave"></el-option>
                <el-option label="转正后才可请假" value="conversion"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="是否带薪假" label-width="120px">
              <el-select v-model="paidHoliday" style="width: 300px">
                <el-option label="带薪假" value="paid"></el-option>
                <el-option label="非带薪假" value="noPaid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <div class="text-tip">若员工请带薪假，将在考勤统计中算出勤</div>
        </div>
      </div>

      <div class="formContainer">
        <el-form :rules="rules">
          <el-col :span="24">
            <el-text class="title">请假时长核算规则</el-text>
          </el-col>

          <el-row class="formRow" style="margin-top: 15px">
            <el-col :span="16">
              <el-form-item label="最小请假单位" label-width="120px">
                <el-select v-model="leaveUnit" placeholder="请选择" style="width: 250px">
                  <el-option v-for="item in leaveUnitList" :key="item.value" :label="item.name" :value="item.value"/>
                  <!--                  <el-option label="按天请假" value="day"></el-option>-->
                  <!--                  <el-option label="按半天请假" value="halfDay"></el-option>-->
                  <!--                  <el-option label="按小时请假" value="hour"></el-option>-->
                </el-select>
                <div class="description" style="width: 300px" v-if="leaveUnit === 'day'">
                  员工以1天为最小单位选择时间，考勤报表按天统计
                </div>
                <div class="description" style="width: 300px" v-if="leaveUnit === 'halfDay'">
                  员工以半天为最小单位选择时间，考勤报表按天统计
                </div>
                <div class="description" style="width: 300px" v-if="leaveUnit === 'hour'">
                  员工以1小时为最小单位选择时间，考勤报表按小时统计
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="formRow">
            <el-col :span="16">
              <el-form-item v-if="leaveUnit === 'hour'" label="请假时长取整"
                            label-width="120px">
                <el-select v-model="leaveRounding" placeholder="请选择" style="width: 250px">
                  <el-option label="不取整" value="noRound"></el-option>
                  <el-option label="向上取整" value="upRound"></el-option>
                  <el-option label="向下取整" value="downRound"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row class="formRow">
            <el-col :span="16">
              <el-form-item label="请假时长核算" label-width="120px">
                <el-select v-model="leaveCalculation" placeholder="请选择" style="width: 250px">
                  <el-option v-for="item in leaveCalculationList" :key="item.value" :label="item.name" :value="item.value"/>
                  <!--                  <el-option label="按工作日计算请假时长" value="workday"></el-option>-->
                  <!--                  <el-option label="按自然日计算请假时长" value="calendarDay"></el-option>-->
                </el-select>
                <div class="description" v-if="leaveCalculation ==='workday'">
                  请假时段中不包含员工的休息日，例如未排班的双休日、法定节假日
                </div>
                <div class="description" v-if="leaveCalculation ==='calendarDay'">请假时段中包含的休息日，也会计入请假天数
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!--  假期余额-->
      <div>
        <el-switch class="formOuterBox" style="margin-left: 50px"
                   v-model="settingsEnabled"
                   inactive-text="设置员工假期余额"
        ></el-switch>
        <div class="formContainer" v-if="settingsEnabled">
          <el-form label-width="120px">
            <el-col :span="18">
              <el-form-item label="余额发放方式">
                <el-select v-model="releaseMethod" placeholder="请选择" style="width: 250px">
                  <el-option v-for="item in releaseMethodList" :key="item.value" :label="item.name" :value="item.value"/>
                  <!--                  <el-option label="每月自动发放1次" value="monthAuto"></el-option>-->
                  <!--                  <el-option label="每年自动发放1次" value="yearAuto"></el-option>-->
                  <!--                  <el-option label="手动发放" value="manual"></el-option>-->
                  <!--                  <el-option label="加班时自动计入余额" value="overtime"></el-option>-->
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 每月自动发放1次     -->
            <el-form v-if="releaseMethod ==='monthAuto'" label-width="120px">
              <el-col :span="18">
                <el-row>
                  <el-form-item label="发放日期">
                    <div class="input-with-prefix-suffix">
                      <span class="input-prefix">每月</span>
                      <el-input-number
                          v-model="releaseDay"
                          style="width: 80px"
                          controls-position="right"
                          :min="1"
                          :max="28">
                      </el-input-number>
                      <span class="input-suffix">日发放</span>
                    </div>
                  </el-form-item>
                </el-row>
              </el-col>
              <el-col :span="18">
                <el-form-item label="额度配置规则">
                  <el-select :disabled="true" v-model="quotaRule" style="width:250px" placeholder="固定额度">
                    <el-option label="固定额度" value="fixedQuota"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-row>
                  <el-form-item label="额度">
                    <div class="input-with-prefix-suffix">
                      <span class="input-prefix">每月每人发放</span>
                      <el-input-number
                          v-model="quotaAmount"
                          style="width: 80px"
                          controls-position="right"
                          :min="1"
                          :max="10">
                      </el-input-number>
                      <span class="input-suffix">小时</span>
                    </div>
                  </el-form-item>
                </el-row>
              </el-col>
              <el-col :span="18">
                <el-form-item label="有效期" disabled="true">
                  <el-select :disabled="true" v-model="validityPeriod" placeholder="自发放日起1个月"
                             style="width: 250px">
                    <el-option label="自发放日起1个月" value="oneMonth"></el-option>
                    <el-option label="自发放日起3个月" value="threeMonths"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item style="margin-left: -70px">
                  <el-checkbox v-model="allowExtension">允许延长有效期</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col v-if="allowExtension === true">
                <el-form-item style="margin-left: -70px">
                  <div class="input-with-prefix-suffix">
                    <span class="input-prefix">超过有效期后，余额保留</span>
                    <el-input-number v-model="balanceRetention"
                                     style="width: 80px"
                                     controls-position="right"
                                     :min="1"></el-input-number>
                    <el-select v-model="reserveTime" style="width: 80px">
                      <el-option label="月" value="mouth"></el-option>
                      <el-option label="天" value="day"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
            </el-form>
            <!-- 每年自动发放1次 -->
            <el-form v-if="releaseMethod ==='yearAuto' " label-width="120px">
              <el-col :span="16">
                <el-form-item label="发放日期">
                  <el-select v-model="issueDate" style="width:250px">
                    <el-option label="每年1月1日" value="annual"></el-option>
                    <el-option label="每年员工入职日" value="entryDay"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="额度配置规则">
                  <el-select v-model="quotaRule" placeholder="请选择" style="width:250px">
                    <!--                    <el-option label="固定额度" value="fixedQuota"></el-option>-->
                    <!--                    <el-option label="按社会工龄(参加工作总年限)" value="socialSeniority"></el-option>-->
                    <el-option label="按司龄(在本公司服务年限)" value="seniority"></el-option>
                    <!--                    <el-option label="社会工龄配额与司龄配额相加" value="together"></el-option>-->
                    <!--                    <el-option label="取社会工龄配额与司龄配额的较大值" value="largerValue"></el-option>-->
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 按社会工龄(参加工作总年限) -->
              <!--              <div style="margin-left: 20px" v-if="quotaRule === 'socialSeniority'">
                              <el-form label-width="150px">
                                <el-text style="margin-left: 20px">工龄配额</el-text>
                                <div style="margin-left: 60px">
                                  <el-row v-for="(societyQuotaItem, index) in societyQuota" :key="index" style="margin-bottom: 5px;"
                                          align="middle">
                                    <el-col :span="7">
                                      <span>{{ societyQuotaItem.experience }}</span>
                                    </el-col>
                                    <el-col :span="6" style="margin-left: -25px">
                                      <el-input-number v-model="societyQuotaItem.hours" controls-position="right" :min="0"/>
                                    </el-col>
                                    <el-col :span="3" style="margin-left: 34px">小时年假</el-col>
                                    <el-col :span="3">
                                      <el-button @click="societyRemoveQuota(index)" type="text"
                                                 v-if="index === societyQuota.length - 1 && societyQuota.length > 1">移除
                                      </el-button>
                                    </el-col>
                                  </el-row>
                                  <el-button type="text" @click="societyAddQuota">新增一条</el-button>
                                </div>
                              </el-form>
                            </div>-->

              <!-- 按司龄(在本公司服务年限) -->
              <div style="margin-left: 20px" v-if="quotaRule === 'seniority'">
                <el-form label-width="150px">
                  <el-text style="margin-left: 20px">司龄配额</el-text>
                  <div style="margin-left: 60px">
                    <el-row v-for="(companyQuotaItem, index) in companyQuota" :key="index" style="margin-bottom: 5px;"
                            align="middle">
                      <el-col :span="7">
                        <span>{{ companyQuotaItem.experience }}</span>
                      </el-col>
                      <el-col :span="6" style="margin-left: -25px">
                        <el-input-number v-model="companyQuotaItem.hours" controls-position="right" :min="0"/>
                      </el-col>
                      <el-col :span="3" style="margin-left: 34px">小时年假</el-col>
                      <el-col :span="3">
                        <el-button @click="companyRemoveQuota(index)" type="text"
                                   v-if="index === companyQuota.length - 1 && companyQuota.length > 1">移除
                        </el-button>
                      </el-col>
                    </el-row>
                    <el-button type="text" @click="companyAddQuota">新增一条</el-button>
                  </div>
                </el-form>
              </div>

              <!-- 社会工龄配额与司龄配额相加 || 取社会工龄配额与司龄配额的较大值 -->
              <!--              <div style="margin-left: 20px" v-if="quotaRule === 'together' || quotaRule === 'largerValue'">
                              <el-form label-width="150px">
                                <el-text style="margin-left: 20px">工龄配额</el-text>
                                <div style="margin-left: 60px">
                                  <el-row v-for="(societyQuotaItem, index) in societyQuota" :key="index" style="margin-bottom: 5px;"
                                          align="middle">
                                    <el-col :span="7">
                                      <span>{{ societyQuotaItem.experience }}</span>
                                    </el-col>
                                    <el-col :span="6" style="margin-left: -25px">
                                      <el-input-number v-model="societyQuotaItem.hours" controls-position="right" :min="0"/>
                                    </el-col>
                                    <el-col :span="3" style="margin-left: 34px">小时年假</el-col>
                                    <el-col :span="3">
                                      <el-button @click="societyRemoveQuota(index)" type="text"
                                                 v-if="index === societyQuota.length - 1 && societyQuota.length > 1">移除
                                      </el-button>
                                    </el-col>
                                  </el-row>
                                  <el-button type="text" @click="societyAddQuota">新增一条</el-button>
                                </div>
                              </el-form>
                              <el-form label-width="150px">
                                <el-text style="margin-left: 20px">司龄配额</el-text>
                                <div style="margin-left: 60px">
                                  <el-row v-for="(companyQuotaItem, index) in companyQuota" :key="index" style="margin-bottom: 5px;"
                                          align="middle">
                                    <el-col :span="7">
                                      <span>{{ companyQuotaItem.experience }}</span>
                                    </el-col>
                                    <el-col :span="6" style="margin-left: -25px">
                                      <el-input-number v-model="companyQuotaItem.hours" controls-position="right" :min="0"/>
                                    </el-col>
                                    <el-col :span="3" style="margin-left: 34px">小时年假</el-col>
                                    <el-col :span="3">
                                      <el-button @click="companyRemoveQuota(index)" type="text"
                                                 v-if="index === companyQuota.length - 1 && companyQuota.length > 1">移除
                                      </el-button>
                                    </el-col>
                                  </el-row>
                                  <el-button type="text" @click="companyAddQuota">新增一条</el-button>
                                </div>
                              </el-form>
                            </div>-->
              <el-col :span="18">
                <el-row>
                  <el-form-item label="额度" label-width="120px">
                    <div class="input-with-prefix-suffix">
                      <span class="input-prefix">每人每年发放</span>
                      <el-input-number
                          v-model="quotaAmount"
                          style="width: 80px"
                          controls-position="right"
                          :min="1"
                          :max="10">
                      </el-input-number>
                      <span class="input-suffix">小时</span>
                    </div>
                  </el-form-item>
                </el-row>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-checkbox v-model="practicalWork">按实际工作时长发余额</el-checkbox>
                  <div class="description" style="width: 400px" v-if="practicalWork === true">
                    例如：每年1月1日发放6天假期，入职时间是6月1日的员工则按照半年发放3天假期，当余额出现小数时按四舍五入取整。
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label="有效期">
                  <el-select :disabled="true" v-model="validityPeriod" placeholder="自发放日起1周年"
                             style="width: 250px">
                    <el-option label="自发放日起1周年" value="naturalYear">自发放日起1周年</el-option>
                  </el-select>
                </el-form-item>
              </el-col>

            </el-form>
            <!--  手动发放    -->
            <el-form v-if="releaseMethod ==='manual' " label-width="120px">
              <el-col :span="16">
                <el-form-item label="有效期">
                  <el-select v-model="validityPeriod" placeholder="" style="width: 250px">
                    <el-option label="按入职日期起12个月" value="entryDate"></el-option>
                    <el-option label="按自然年(1月1日-12月31日)" value="naturalYear"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16" style="margin-left: 50px">
                <el-checkbox v-model="allowExtension" style="margin-top: -20px">允许延长有效期</el-checkbox>
              </el-col>
              <el-col v-if="allowExtension === true">
                <el-form-item style="margin-left: -50px">
                  <div class="input-with-prefix-suffix">
                    <span class="input-prefix">超过有效期后，余额保留</span>
                    <el-input-number v-model="balanceRetention"
                                     style="width: 80px"
                                     controls-position="right"
                                     :min="1"></el-input-number>
                    <el-select v-model="reserveTime" style="width: 80px">
                      <el-option label="月" value="mouth"></el-option>
                      <el-option label="天" value="day"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
            </el-form>
            <!-- 加班自动计入余额     -->
            <el-form v-if="releaseMethod ==='overtime' " label-width="120px">
              <el-form style="margin-left:50px">
                <el-col>
                  <el-text>发放规则</el-text>
                </el-col>
                <el-row>
                  <el-text>根据加班时长计算余额。已设置加班时长计算规则，</el-text>
                  <el-button type="text" class="view-button">查看</el-button>
                </el-row>
              </el-form>
              <el-col :span="16">
                <el-form-item label="有效期">
                  <el-select v-model="validityPeriod" placeholder="请选择有效期" style="width: 250px">
                    <el-option label="每年固定时间作废" value="yearFixedDestroy"></el-option>
                    <el-option label="加班后多少天后作废" value="overtimeDestroy"></el-option>
                    <el-option label="永久有效" value="forever"></el-option>
                    <el-option label="每月固定时间作废" value="mouthFixedDestroy"></el-option>
                    <el-option label="每季度末作废" value="quarterDestroy"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="18">
                <el-row v-if="validityPeriod === 'yearFixedDestroy'">
                  <el-form-item>
                    <div class="input-with-prefix-suffix">
                      <span class="input-prefix">每年</span>
                      <el-date-picker v-model="annuallyFixedDestroy" style="width: 150px" position="letf"
                                     format="MM-DD" value-format="MM-DD">
                      </el-date-picker>
                      <span>后作废</span>
                    </div>
                  </el-form-item>
                </el-row>
              </el-col>
              <el-col :span="18">
                <el-row v-if="validityPeriod === 'overtimeDestroy'">
                  <el-form-item>
                    <div class="input-with-prefix-suffix">
                      <span class="input-prefix">加班</span>
                      <el-input-number v-model="overtimeAfterDestroy" style="width: 100px" controls-position="right"
                                       :min="1">
                      </el-input-number>
                      <span class="input-suffix">天后作废</span>
                    </div>
                  </el-form-item>
                </el-row>
              </el-col>

              <el-row>
                <el-col :span="18">
                  <el-form-item v-if="validityPeriod === 'mouthFixedDestroy'">
                    <div class="input-with-prefix-suffix">
                      <span class="input-prefix">每月</span>
                      <el-select v-model="selectedDay" style="width: 100px;">
                        <el-option v-for="mouthDestroy in days" :key="mouthDestroy" :value="mouthDestroy">
                        </el-option>
                      </el-select>
                      <span class="input-suffix">日后作废</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-col v-if="validityPeriod === 'quarterDestroy'">
                <el-form-item>
                  <el-text style="margin-top: -18px">每季度最后一日作废</el-text>
                </el-form-item>
              </el-col>
              <el-form v-if="validityPeriod === 'yearFixedDestroy'" style="margin-left: 50px">
                <el-checkbox v-model="allowExtension" style="margin-top: -20px">允许延长有效期</el-checkbox>
                <el-col v-if="allowExtension === true">
                  <div class="input-with-prefix-suffix">
                    <span class="input-prefix">超过有效期后，余额保留</span>
                    <el-input-number v-model="balanceRetention"
                                     style="width: 80px"
                                     controls-position="right"
                                     :min="1"></el-input-number>
                    <el-select v-model="reserveTime" style="width: 80px">
                      <el-option label="月" value="mouth"></el-option>
                      <el-option label="天" value="day"></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-form>
              <!--              <el-switch style="margin-left: 50px"
                                       v-model="expirationReminderBox"
                                       inactive-text="假期过期提醒">
                            </el-switch>
                            <el-col v-if="expirationReminderBox === true">
                              <el-text style="margin-left:50px">提醒时间</el-text>
                              <el-col :span="20" style="margin-left:-70px">
                                <el-form-item>
                                  <div class="input-with-prefix-suffix">
                                    <span class="input-prefix">假期过期前</span>
                                    <el-select v-model="reminderTime" style="width: 250px">
                                      <el-option label="1个月" value="entryDate"></el-option>
                                      <el-option label="15天" value="naturalYear"></el-option>
                                      <el-option label="7天" value="naturalYear"></el-option>
                                      <el-option label="3天" value="naturalYear"></el-option>
                                    </el-select>
                                  </div>
                                </el-form-item>
                              </el-col>
                              <el-col style="margin-left:50px">
                                <el-text>提醒范围</el-text>
                              </el-col>
                              <el-col :span="12" style="margin-left:50px">
                                <el-checkbox v-model="notifyStaff">通知员工</el-checkbox>
                              </el-col>
                              <el-col :span="12" style="margin-left:50px">
                                <el-checkbox v-model="notifyDepartmentHead">通知部门主管</el-checkbox>
                                <div class="description">必须选择一个,默认为都选</div>
                              </el-col>
                            </el-col>-->
            </el-form>
          </el-form>
        </div>
      </div>
      <!-- 全局取消和保存按钮 -->
      <div class="global-buttons">
        <el-button v-if="componentParam !== 'edit'" type="primary" class="global-save" @click="saveAll">保存</el-button>
        <el-button v-if="componentParam === 'edit'" type="primary" class="global-save" @click="saveAllEdit">保存</el-button>
        <el-button class="global-cancel" @click="cancel">取消</el-button>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "VacationRules",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      rules: {
        vacationName: [{required: true, message: '假期名称', trigger: 'blur'}],
        scope: [{required: true, message: '应用范围', trigger: 'blur'}]
      },
      vacationName: '',
      scope: '全公司',
      employeeLeave: '入职即可请假',
      paidHoliday: '带薪假',
      leaveUnit: '按天请假',
      // 取整
      leaveRounding: '不取整',
      // 请假时长核算
      leaveCalculation: '',
      settingsEnabled: false,
      // 余额发放方式
      releaseMethod: 'yearAuto',
      releaseDay: '',
      quotaRule: '',
      quotaAmount: '',
      validityPeriod: '',
      allowExtension: false,
      practicalWork: false,
      issueDate: '每年1月1日',
      selectedPerson: '',
      expirationReminderBox: false,
      reminderTime: '1个月',
      // 单选框
      notifyStaff: true,
      notifyDepartmentHead: true,
      balanceRetention: '',
      reserveTime: '月',
      overtimeAfterDestroy: '',
      selectedDay: '1', // 默认选择第1天
      departmentDialogVisible: false,
      days: Array.from({length: 31}, (_, i) => i + 1),
      mouthDestroy:'',
      annuallyFixedDestroy:'',
      societyQuota: [
        {experience: "工龄 < 1 年，享有", hours: 5},
        {experience: "工龄 ≥ 1 年，享有", hours: 6},
        {experience: "工龄 ≥ 2 年，享有", hours: 7},
        {experience: "工龄 ≥ 3 年，享有", hours: 8}
      ],
      companyQuota: [
        {experience: "司龄 < 1 年，享有", hours: 5},
        {experience: "司龄 ≥ 1 年，享有", hours: 6},
        {experience: "司龄 ≥ 2 年，享有", hours: 7},
        {experience: "司龄 ≥ 3 年，享有", hours: 8}
      ],
      nextYearForSociety: 4,
      nextYearForCompany: 4,
    };
  },
  computed: {
    leaveUnitList() {
      return this.$store.getters['core/getDictList']('vacation_leave_unit');
    },
    leaveCalculationList(){
      return this.$store.getters['core/getDictList']('vacation_leave_calculation');
    },
    releaseMethodList(){
      return this.$store.getters['core/getDictList']('vacation_release_method');
    },
    scopeList(){
      return this.$store.getters['core/getDictList']('vacation_scope');
    },
    isAtLeastOneChecked() {
      return this.notifyStaff || this.notifyDepartmentHead;
    },
  },
  /*  watch: {
      //   监听两个复选框的状态
      notifyStaff() {
        this.checksSelection();
      },
      notifyDepartmentHead() {
        this.checksSelection();
      }
    },*/
  methods: {
    societyAddQuota() {
      this.societyQuota.push({
        experience: `工龄 ≥ ${this.nextYearForSociety} 年，享有`,
        hours: 0
      });
      this.nextYearForSociety++;
    },
    societyRemoveQuota(index) {
      this.societyQuota.splice(index, 1);
      this.nextYearForSociety--;
    },
    companyAddQuota() {
      this.companyQuota.push({
        experience: `司龄 ≥ ${this.nextYearForCompany} 年，享有`,
        hours: 0
      });
      this.nextYearForCompany++;
    },
    companyRemoveQuota(index) {
      this.companyQuota.splice(index, 1);
      this.nextYearForCompany--;
    },

    cancel() {
      this.$fn.closeWindow();
    },
    async saveAll() {
      // 处理全局保存的逻辑
      if (this.vacationName === null || this.vacationName.length === 0) {
        this.$message({
          message: "请填写假期名称",
          type: "error",
        });
        return;
      }
      if (this.scope === null) {
        this.$message({
          message: "请选择应用范围",
          type: "error",
        });
        return;
      }
      let params = {
        scope: this.scope,
        employeeLeave: this.employeeLeave,
        value: this.value,
        paidHoliday: this.paidHoliday,
        leaveUnit: this.leaveUnit,
        leaveRounding: this.leaveRounding,
        leaveCalculation: this.leaveCalculation,
        settingsEnabled: this.settingsEnabled,
        releaseMethod: this.releaseMethod,
        releaseDay: this.releaseDay,
        quotaRule: this.quotaRule,
        quotaAmount: this.quotaAmount,
        validityPeriod: this.validityPeriod,
        allowExtension: this.allowExtension,
        practicalWork: this.practicalWork,
        vacationName: this.vacationName,
        issueDate: this.issueDate,
        selectedPerson: this.selectedPerson,
        expirationReminderBox: this.expirationReminderBox,
        reminderTime: this.reminderTime,
        notifyStaff: this.notifyStaff,
        notifyDepartmentHead: this.notifyDepartmentHead,
        balanceRetention: this.balanceRetention,
        reserveTime: this.reserveTime,
        overtimeDestroy: this.overtimeDestroy,
        overtimeAfterDestroy: this.overtimeAfterDestroy,
        selectedDay: this.selectedDay,
        mouthDestroy: this.mouthDestroy,
        annuallyFixedDestroy:this.annuallyFixedDestroy,
        departmentDialogVisible: this.departmentDialogVisible
      }
      await this.$http("vacationRulesService.saveVacationData", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    // 编辑保存的逻辑
    async saveAllEdit() {
      if (this.vacationName === null || this.vacationName.length === 0) {
        this.$message({
          message: "请填写假期名称",
          type: "error",
        });
        return;
      }
      if (this.scope === null) {
        this.$message({
          message: "请选择应用范围",
          type: "error",
        });
        return;
      }
      let params = {
        id: this.parentData.id,
        scope: this.scope,
        employeeLeave: this.employeeLeave,
        value: this.value,
        paidHoliday: this.paidHoliday,
        leaveUnit: this.leaveUnit,
        leaveRounding: this.leaveRounding,
        leaveCalculation: this.leaveCalculation,
        settingsEnabled: this.settingsEnabled,
        releaseMethod: this.releaseMethod,
        releaseDay: this.releaseDay,
        quotaRule: this.quotaRule,
        quotaAmount: this.quotaAmount,
        validityPeriod: this.validityPeriod,
        allowExtension: this.allowExtension,
        practicalWork: this.practicalWork,
        vacationName: this.vacationName,
        issueDate: this.issueDate,
        selectedPerson: this.selectedPerson,
        expirationReminderBox: this.expirationReminderBox,
        reminderTime: this.reminderTime,
        notifyStaff: this.notifyStaff,
        notifyDepartmentHead: this.notifyDepartmentHead,
        balanceRetention: this.balanceRetention,
        reserveTime: this.reserveTime,
        overtimeDestroy: this.overtimeDestroy,
        overtimeAfterDestroy: this.overtimeAfterDestroy,
        selectedDay: this.selectedDay,
        departmentDialogVisible: this.departmentDialogVisible,
        mouthDestroy:this.mouthDestroy,
        annuallyFixedDestroy:this.annuallyFixedDestroy
      }
      await this.$http("vacationRulesService.updateVacationRules", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("vacationRulesService.getClassById", params);
        this.vacationName =data.vacation_name;
        this.scope=data.scope;
        this.employeeLeave=data.employee_leave;
        this.paidHoliday=data.paid_holiday;
        this.leaveUnit=data.leave_unit;
        this.leaveRounding=data.leave_rounding;
        this.leaveCalculation=data.leave_calculation;
        this.settingsEnabled=data.settings_enabled;
        this.releaseMethod=data.release_method;
        this.releaseDay=data.release_day;
        this.quotaRule=data.quota_rule;
        this.quotaAmount=data.quota_amount;
        this.validityPeriod=data.validity_period;
        this.allowExtension=data.allow_extension;
        this.practicalWork=data.practical_work;
        this.issueDate=data.issue_date;
        this.selectedPerson=data.selected_person;
        this.expirationReminderBox=data.expiration_reminder_box;
        this.reminderTime=data.reminder_time;
        this.notifyStaff=data.notify_staff;
        this.notifyDepartmentHead=data.notify_department_head;
        this.balanceRetention=data.balance_retention;
        this.reserveTime=data.reserve_time;
        this.overtimeAfterDestroy=data.overtime_after_destroy;
        this.selectedDay=data.selected_day;
        this.mouthDestroy=data.mouthDestroy;
        this.annuallyFixedDestroy=data.annually_fixeddestroy;
      }
    },
    // 至少选择一个复选框
    checksSelection() {
      if (!this.notifyStaff && !this.notifyDepartmentHead) {
        this.notifyStaff = true;
      }
    }
  },
  mounted() {
    this.getData();
  }
}

</script>


<style lang="less" scoped>
@import '../../../global';
</style>

<style scoped>
.formOuterBox {
  margin-bottom: 5px;
  margin-top: 10px;
  padding: 5px 5px;
  border-radius: 10px;

}

.text-tip {
  margin-top: -15px; /* 控制与上方select的间距 */
  margin-left: 120px;
  color: #888;
  font-size: 12px; /* 根据需要调整颜色 */
}

.formRow {
  margin-left: 5px;
  margin-bottom: 5px;
  margin-top: -13px;
}

.formContainer {
  padding: 10px;
  background-color: #f3f2f2; /* 灰色背景 */
  border-radius: 5px;
  margin-right: 50px;
  margin-left: 50px;
}

.description {
  margin-top: 1px;
  color: #888;
  font-size: 12px;
  line-height: 1.5; /* 行间距 */
}

.space-x-4 > * + * {
  margin-left: 1rem;
}

.global-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.title {
  margin: 10px 0px 0px 10px;
  font-size: 14px;
}

.box {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: row;
}
.box > div {
  height: 100%;
  flex: 1;
}

h3 {
  margin: 0px 0px 20px 0px;
}
</style>
